<template>
  <div class="reward-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="card">
          <div class="title">如下商品随机抽取派发</div>
          <div class="options">
            <!-- <div :class="['optionWx', { active: receiveType !== 1 }]" @click="receiveType = 1">微信立减金</div>
            <div :class="['optionJf', { active: receiveType !== 2 }]" @click="receiveType = 2">商城积分</div> -->
            <div class="benefit-option">
              <div class="benefit-name">微信立减金</div>
              <div class="benefit-price">{{ benefitList[+userRightsLevel][0] }}</div>
            </div>
            <div class="benefit-option">
              <div class="benefit-name">微信立减金</div>
              <div class="benefit-price">{{ benefitList[+userRightsLevel][1] }}</div>
            </div>
          </div>
          <img
            class="confirm-btn"
            :src="require('@/assets/imgs/xibNewCustomerGift/rewardBtn.png')"
            @click="onConfirm"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { xibNewCustomerReceive } from '@/api/xibNewCustomerGift'
import { generateLink2 } from '@/api/communal'
export default {
  name: 'RewardModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userRightsToken: {
      type: String,
      default: ''
    }, // 领取权益token
    userRightsLevel: {
      type: String,
      default: '1'
    } // 权益等级 * 1，达标财富客户：可随机抽取58元或88元微信立减金一份
    //  * 2，达标白金客户：可随机抽取158元或218元微信立减金一份
    //  * 3，达标黑金客户：可随机抽取318元或388元微信立减金一份
    //  * 4，达标私钻客户：可随机抽取518元或688元微信立减金一份
  },
  data() {
    return {
      receiveType: 1, // 领取类型，1-微信立减金，2-厦门国际银行积分
      benefitList: {
        1: ['58元', '88元'],
        2: ['158元', '218元'],
        3: ['318元', '388元'],
        4: ['518元', '688元']
      } // 权益列表权益等级
    }
  },
  methods: {
    async onConfirm() {
      const selectedReceiveType = this.receiveType // 已选中权益类型
      // 如果是微信立减金则跳转到小程序(然后嵌入我们微信权益详情页进行授权登录领取)
      if (selectedReceiveType === 1) {
        this.$emit('confirm')
        this.jumpWxDetail()
        return
      }

      const { data } = await xibNewCustomerReceive({
        userRightsToken: this.userRightsToken,
        receiveType: selectedReceiveType // 权益类型：1-微信立减金，2-厦门国际银行积分
      })
      this.$emit('confirm')
      // sendRes发放结果：1-发放成功，0-发放失败
      if (data.sendRes === 1) {
        this.$router.push({
          path: '/xibNewCustomerGiftJfDetail',
          query: { stockName: data?.goodsList[0]?.stockName }
        })
      } else {
        this.$router.push({ path: '/xiameBankPromotionGiftFailDetail' })
      }
    },
    // 跳转微信小程序内嵌厦门国际银行微信详情页领取立减金
    async jumpWxDetail() {
      const urlToken = sessionStorage.getItem('xiameBankPromotionJhToken')
      const url = `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-ph-h5-bankv3/xibNewCustomerGiftWxDetail?urlToken=${urlToken}&userRightsToken=${this.userRightsToken}`
      // window.location.href = url
      const { data } = await generateLink2({
        link: encodeURIComponent(url)
      })
      window.location.href = data.urlLink
    }
  }
}
</script>

<style lang="less" scoped>
.reward-modal {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    box-sizing: border-box;
  }
  .card {
    width: 312px;
    height: 346px;
    background: url('~@/assets/imgs/xibNewCustomerGift/rewardBg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-top: 60px;
      font-size: 15px;
      color: #b33e12;
    }
    .options {
      margin-top: 26px;
      display: flex;
      align-items: center;
      gap: 30px; // 间距可调整
      font-size: 12px;
      color: #e5713e;
      text-align: center;
      height: 118px;
      .optionWx {
        width: 92px;
        height: 118px;
        background: url('~@/assets/imgs/xibNewCustomerGift/rewardWx.png');
        background-size: contain;
        padding-top: 26px;
        box-sizing: border-box;
      }
      .optionJf {
        width: 92px;
        height: 118px;
        background: url('~@/assets/imgs/xibNewCustomerGift/rewardJf.png');
        background-size: contain;
        padding-top: 26px;
        box-sizing: border-box;
      }
      .active {
        opacity: 0.6;
      }
      .benefit-option {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        position: relative;
        padding: 22px 0 15px;
        box-sizing: border-box;
        z-index: 2;
        width: 92px;
        height: 118px;
        background: url('~@/assets/imgs/xibNewCustomerGift/rewardWxBg.png')
          no-repeat;
        background-size: contain;
        .benefit-name {
          font-size: 12px;
          color: #e5713e;
          font-weight: bold;
        }
        .benefit-price {
          text-align: center;
          font-size: 10px;
          font-weight: bold;
          color: #fce7c2;
          width: 45px;
          height: 15px;
          line-height: 15px;
          background: url('~@/assets/imgs/xibNewCustomerGift/eqBg4.png');
          background-size: 100% 100%;
        }
      }
    }
    .confirm-btn {
      width: 157px;
      height: 57px;
      margin-top: 28px;
    }
  }
}
</style>
